
import { NewsItem } from '@/types/dashboard';

/**
 * Extract and process news items from various data structures
 */
export function extractNewsItems(newsData: any): NewsItem[] {
  let newsItems: NewsItem[] = [];

  if (newsData && typeof newsData === 'object') {
    // Handle different possible structures of news data
    if (Array.isArray(newsData)) {
      newsItems = newsData;
    } else if (newsData.items && Array.isArray(newsData.items)) {
      newsItems = newsData.items;
    } else if (newsData.news && Array.isArray(newsData.news)) {
      newsItems = newsData.news;
    }
  }



  return newsItems;
}

/**
 * Sort news items by date (newest first)
 */
export function sortNewsByDate(newsItems: NewsItem[]): NewsItem[] {
  try {
    return [...newsItems].sort((a, b) => {
      // Handle potential invalid dates
      const dateA = new Date(a.pubDate || a.date || '');
      const dateB = new Date(b.pubDate || b.date || '');

      // Check if the dates are valid
      if (isNaN(dateA.getTime()) && isNaN(dateB.getTime())) return 0;
      if (isNaN(dateA.getTime())) return 1;
      if (isNaN(dateB.getTime())) return -1;

      return dateB.getTime() - dateA.getTime();
    });
  } catch (error) {
    console.error("Error sorting news:", error);
    return newsItems; // Fallback to unsorted
  }
}

/**
 * Process news data and return sorted latest news
 */
export function processNewsData(newsData: any): NewsItem[] {
  const newsItems = extractNewsItems(newsData);
  const sortedNews = sortNewsByDate(newsItems);
  return sortedNews; // Return all sorted items, let UI handle slicing
}
